export const mobileView = window.matchMedia('(max-width: 768px)').matches;
export const desktopView =  window.matchMedia('(min-width: 769px)').matches;